import React from 'react';
//<88181> 		 
const ListadoEquipoExterno = props => (
  <tbody>
    {
      props.equisvehiculoE.length ?
        props.equisvehiculoE.map((equivehiculo, index) => (
          <tr key={index}>
            <td>{equivehiculo.codEquipoVeh}</td>
            <td>{equivehiculo.desEquipoVeh}</td>
            <td>{equivehiculo.tipo}</td>
            <td>{equivehiculo.cantidad}</td>
            <td>{equivehiculo.indRevision}</td>
            <td>{equivehiculo.indEntrega}</td>
            <td>{equivehiculo.indImpresion}</td>
            <td>{equivehiculo.indInactivo}</td>
            <td>
              <div className='col-md-1'>
                <input id={`p_indImpWeb_` + index} name={`p_indImpWeb`} type='checkbox'
                  onChange={e => props.onUpdateItem(e, index)}
                  defaultChecked={equivehiculo.indImpWeb === 'S' ? true : false} />
              </div>
            </td>
            <td>
              <input className='form-control'
                id={`p_numOrdenWeb_` + index}
                name={`p_numOrdenWeb`}
                type="number"
                step="1"
                min="1"
                max="100"
                onChange={e => props.onUpdateItem(e, index)}
                defaultValue={equivehiculo.numOrdenWeb} />

            </td>
          </tr>
        )) :
        <tr>
          <td colSpan={8}>No hay resultados</td>
        </tr>
    }
  </tbody>
);
export default ListadoEquipoExterno;






// WEBPACK FOOTER //
// ./src/pages/MantSkuVehiculo/ListadoEquipoExterno.js